module.exports = __webpack_public_path__ + "img/59.2.TN.c8b467e3.png";